/**
 * "Is this ray on a VR panel or button?" — a press aimed at the palette, the
 * library, the wrist bar or the keyboard belongs to that UI, never to a grab or
 * a two-hand gesture.
 */
import * as THREE from 'three';

const VR_UI = /^vr-(build-palette|palette|library|lib-|texture|editor|edmenu|wrist|menu|hands-tips|key)/;

export function isVrUi(o: THREE.Object3D | null): boolean {
  for (let p = o; p; p = p.parent) if (VR_UI.test(p.name)) return true;
  return false;
}

/** Does the ray hit VR UI within `far` metres? (`ray` is reused: its origin, direction and far are overwritten.) */
export function rayHitsUi(ray: THREE.Raycaster, scene: THREE.Object3D, origin: THREE.Vector3, dir: THREE.Vector3, far: number): boolean {
  ray.set(origin, dir); ray.far = far;
  for (const h of ray.intersectObjects(scene.children, true)) if (isVrUi(h.object)) return true;
  return false;
}
